module.exports = __webpack_public_path__ + "static/media/taimalishan_mobile.7cb37fc5.webp";